import { getTourConfirmationType, getToursConfirmationType } from "./lib/typeConfirmation";
import TourAttentionAlert from './ui/TourAttentionAlert.vue';
import { type TourProduct } from './types/ITourProduct';
import TourProductModel from './model/TourProduct';
import { FlightType } from "./types/IFlightType";
import { HotelAvailable } from "./types/IHotelAvailable";
import { type IOperator } from '@entities/operator/types/IOperator';
import { ref } from 'vue';

export interface IRawTourProduct {
    id: string;
    price: number;
    oilTax: number | null;
    hotelAvailable: HotelAvailable;
    medicalInsurance: boolean;
    transferType: TourProduct['transferType'];
    flightType: string;
    operator: number;
    hotel: number;
    room?: { id: number };
    firstPaymentDefinitions?: number[];
    [key: string]: unknown;
}

export function useTourProductsRepository() {
    return {
        tourProducts: ref<IRawTourProduct[]>([]),
    };
}

export function groupTourProductsByHotel(tourProducts: TourProduct[]): Record<string, TourProduct[]> {
    return {};
}

export function getGroupedOperators(_grouped: Record<string, TourProduct[]>): IOperator[][] {
    return [];
}

export {
    TourAttentionAlert,
    getTourConfirmationType,
    getToursConfirmationType,
    TourProduct,
    TourProductModel,
    FlightType,
}